// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */
var RowDragClueVue2 = {
  name: 'KendoRowClue',
  props: {
    visible: Boolean,
    top: Number,
    left: Number,
    text: String,
    allowDrop: Boolean
  },
  computed: {
    statusClass: function statusClass() {
      var _a;
      return _a = {
        'k-icon': true,
        'k-drag-status': true
      }, _a[this.$props.allowDrop ? 'k-i-plus' : 'k-i-cancel'] = true, _a['k-icon-with-modifier'] = true, _a;
    }
  },
  mounted: function mounted() {
    var body = document.body;
    this.windowElement = this.$refs.wrapper;
    body.append(this.windowElement);
  },
  beforeDestroy: !!isV3 ? undefined : function () {
    this.windowElement.remove();
  },
  // @ts-ignore
  beforeUnmount: function beforeUnmount() {
    this.windowElement.remove();
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return this.visible && h("div", {
      "class": "k-header k-drag-clue",
      ref: 'wrapper',
      style: {
        display: 'block',
        position: 'absolute',
        zIndex: 20000,
        padding: '8px 12px',
        top: this.$props.top + 'px',
        left: this.$props.left + 'px'
      }
    }, [h("span", {
      "class": this.statusClass
    }, [h("span", {
      "class": "k-icon k-icon-modifier"
    })]), this.$props.text]);
  }
};
/**
 * @hidden
 */
var RowDragClue = RowDragClueVue2;
export { RowDragClue, RowDragClueVue2 };